export const naceATemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.test.nace_a.pq' },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.test.nace_a.control_lot' },
  { header: 'generateReport.dataToResult.report.test.nace_a.diametro_size_mm' },
  {
    header: 'generateReport.dataToResult.report.test.nace_a.espessura_size_mm',
  },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.test.nace_a.material' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.test.nace_a.steel_grade' },
  { header: 'generateReport.dataToResult.report.test.nace_a.inspection' },
  { header: 'generateReport.dataToResult.report.test.nace_a.le_psi' },
  { header: 'generateReport.dataToResult.report.test.nace_a.carga_do_teste' },
  { header: 'generateReport.dataToResult.report.test.nace_a.sample_number' },
  { header: 'generateReport.dataToResult.report.test.nace_a.pipe' },
  { header: 'generateReport.dataToResult.report.test.nace_a.treatment_lot' },
  { header: 'generateReport.dataToResult.report.test.nace_a.position' },
  {
    header:
      'generateReport.dataToResult.report.test.nace_a.material_identification',
  },
  {
    header: 'generateReport.dataToResult.report.test.nace_a.dynanometer_number',
  },
  { header: 'generateReport.dataToResult.report.test.nace_a.roughness' },
  { header: 'generateReport.dataToResult.report.test.nace_a.sample_diameter' },
  { header: 'generateReport.dataToResult.report.test.nace_a.ph_inicial' },
  { header: 'generateReport.dataToResult.report.test.nace_a.ph_pos_saturacao' },
  { header: 'generateReport.dataToResult.report.test.nace_a.ph_final' },
  {
    header:
      'generateReport.dataToResult.report.test.nace_a.concentracao_h2s_inicial',
  },
  {
    header:
      'generateReport.dataToResult.report.test.nace_a.concentracao_h2s_final',
  },
  { header: 'generateReport.dataToResult.report.test.nace_a.result' },
  { header: 'generateReport.dataToResult.report.test.nace_a.start_test_date' },
  { header: 'generateReport.dataToResult.report.test.nace_a.finish_test_date' },
]
